import { mapStates, mapActions, mapMutations, mapGetters } from './../baseModule'

const collection = {$exists: false}
const singleName = 'state'
const pluralName = 'states'

const model = {
  cidades: [],
  nome: '',
  sigla: ''
}

const validations = {
  nome: {
    required: true
  },
  informativeText: {
    sigla: true
  }
}

let getters = { ...mapGetters() }
getters[singleName] = state => state.one
getters[pluralName] = state => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count,
  statesOptions: state => {
    let statesOptions = []
    for (let item of state.all) {
      statesOptions.push({
        value: item.sigla,
        label: item.nome
      })
    }
    return statesOptions
  }
})

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0,
    cities: []
  },
  mutations: {
    ...mapMutations(),
    SET_CITIES (state, payload) {
      state.cities = payload
    }
  },
  actions: {
    ...mapActions(collection, model, 'states'),
    setCities (context, payload) {
      context.commit('SET_CITIES', payload)
    }
  },
  getters: {
    ...getters,
    cities: state => state.cities
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/states.js